import React from "react";
import TailsOfStartupCard from "../../common/tails-of-startup-card";

const Preview = () => {
  return (
    <>
      <div className="flex justify-center mt-8">
        <TailsOfStartupCard />
      </div>
    </>
  );
};

export default Preview;
